import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { BrowserRouter } from 'react-router-dom'
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './authentication/authConfig';
import { msalInstance } from './authentication/useAccessToken.js'


const initializeApp = async () => {
  try {
    await msalInstance.initialize();
    const accounts = msalInstance.getAllAccounts();
  
    
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
     
    }
    msalInstance.addEventCallback((event) => {
    
      
      switch (event.eventType) {
        case EventType.LOGIN_SUCCESS:
          if (event.payload?.account) {
          
            msalInstance.setActiveAccount(event.payload.account);
          }
          break;
          
        case EventType.ACCOUNT_ADDED:
          if (event.payload?.account) {
       
            msalInstance.setActiveAccount(event.payload.account);
          }
          break;
          
        case EventType.LOGIN_FAILURE:
       
          break;
          
        case EventType.ACQUIRE_TOKEN_FAILURE:
         
          break;
      }
    });

  
    
    // Render the app
    createRoot(document.getElementById('root')).render(
      // <StrictMode>
        <BrowserRouter>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </BrowserRouter>
      // </StrictMode>
    );
    
  } catch (error) {
    console.error(" MSAL initialization failed:", error);
     console.error("Error details:", {
      name: error.name,
      message: error.message,
      errorCode: error.errorCode
    });
    
    
    createRoot(document.getElementById('root')).render(
      <StrictMode>
        <BrowserRouter>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </BrowserRouter>
      </StrictMode>
    );
  }
};

// Start the app
initializeApp();